import { render, staticRenderFns } from "./dialog-video.vue?vue&type=template&id=d05ac10a&scoped=true"
import script from "./dialog-video.vue?vue&type=script&lang=js"
export * from "./dialog-video.vue?vue&type=script&lang=js"
import style0 from "./dialog-video.vue?vue&type=style&index=0&id=d05ac10a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05ac10a",
  null
  
)

export default component.exports